import React, { useState } from 'react'
import PropTypes from 'prop-types'
import { useMutation } from '@apollo/client'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Button from '@material-ui/core/Button'
import CircularProgress from '@material-ui/core/CircularProgress'
import DialogActions from '@material-ui/core/DialogActions'
import Typography from '@material-ui/core/Typography'
import SendIcon from 'components/material-symbol/icons/Send'
import { RequestCoachReviews } from './query'
import useStyles from './styles'
import { gtmEvent } from 'lib/gtm'
import pluralize from 'lib/pluralize'

const ConfirmSendModal = ({ contactsArr, setOpen, setStep, setError }) => {
  const [loading, setLoading] = useState(false)
  const [requestCoachReviews] = useMutation(RequestCoachReviews)
  const styles = useStyles()

  const setGTMEvent = obj => {
    gtmEvent({
      event: 'formSubmit',
      formCategory: 'reviews',
      formAction: 'send-review-request',
      ...obj,
    })
  }

  const handleReviewRequest = async () => {
    try {
      setLoading(true)
      await requestCoachReviews({ variables: { params: { contactsArr } } })

      setGTMEvent({ formStatus: 'success' })

      setLoading(false)
      setStep(2)
    } catch (e) {
      setGTMEvent({
        formStatus: 'error',
        errorDescription: e.message,
      })
      setLoading(false)
      setError(e)
      setStep(2)
    }
  }

  return (
    <>
      <DialogTitle disableTypography classes={{ root: styles.titleRoot }}>
        <Typography component="h2" variant="inherit" className={styles.title}>
          {`Send review request to ${contactsArr.length} ${pluralize(
            contactsArr,
            'contact',
          )}?`}
        </Typography>
      </DialogTitle>
      {loading ? (
        <CircularProgress className={styles.loading} color="primary" />
      ) : null}
      <DialogContent classes={{ root: styles.content }}>
        <Typography className={styles.bodyText}>
          Are you sure you want to send an email to {contactsArr.length}{' '}
          {pluralize(contactsArr, 'contact')} requesting a review of your
          coaching program?
        </Typography>
      </DialogContent>
      <DialogActions classes={{ root: styles.actionsWrapper }}>
        <Button
          onClick={() => {
            setStep(0)
            setOpen(false)
          }}
          color="primary"
        >
          Cancel
        </Button>
        <Button
          onClick={handleReviewRequest}
          color="primary"
          variant="contained"
          disabled={loading}
          startIcon={<SendIcon />}
        >
          Send Review
        </Button>
      </DialogActions>
    </>
  )
}

ConfirmSendModal.propTypes = {
  contactsArr: PropTypes.array,
  open: PropTypes.bool,
  setOpen: PropTypes.func,
  setStep: PropTypes.func,
  setError: PropTypes.func,
}

export default ConfirmSendModal
